// Font family for consistent typography
export const FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

// Background colors for speaker identification
export const BACKGROUND_COLORS = [
  '#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c',
  '#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928'
];

// Card states for managing UI interactions
export const CARD_STATES = {
  EDITABLE_TEXT: 'editableText',
  HOVER_CARD: 'hooverCard',
  HOVER_SPEAKER: 'hooverSpeaker',
  EDITABLE_SPEAKER: 'editableSpeaker'
};

// Default card state
export const DEFAULT_CARD_STATE = {
  [CARD_STATES.EDITABLE_TEXT]: false,
  [CARD_STATES.HOVER_CARD]: false,
  [CARD_STATES.HOVER_SPEAKER]: false,
  [CARD_STATES.EDITABLE_SPEAKER]: false
};

// Loading and rendering limits
export const INITIAL_LOAD_LIMIT = 10;
export const RENDER_DELAY = 1000;
export const UPDATE_DELAY = 100; 